import { render, staticRenderFns } from "./QuartersUpdate.vue?vue&type=template&id=4ff1c07c"
import script from "./QuartersUpdate.vue?vue&type=script&lang=js"
export * from "./QuartersUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports